import { render, staticRenderFns } from "./Giras.vue?vue&type=template&id=ee186fe4"
import script from "./Giras.vue?vue&type=script&lang=js"
export * from "./Giras.vue?vue&type=script&lang=js"
import style0 from "./Giras.vue?vue&type=style&index=0&id=ee186fe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports